import * as tslib_1 from "tslib";
import handleGetSharingInfoResponse from './handleGetSharingInfoResponse';
import shouldProcessLink from './shouldProcessLink';
import trySetIdAndClassName from './trySetIdAndClassName';
import getSharingInformation from '../actions/getSharingInformation';
import datapoints from '../datapoints';
import isSharePointLink from '../utils/isSharePointLink';
import { logUsage } from 'owa-analytics';
import { PerformanceDatapoint } from 'owa-analytics';
export var ANCHOR_TAG_NAME = 'a';
var ORIGINALSRC_ATTRIBUTE_NAME = 'originalsrc';
export var AnchorElementsSource;
(function (AnchorElementsSource) {
    // User pastes html
    AnchorElementsSource[AnchorElementsSource["PasteHtml"] = 0] = "PasteHtml";
    // Loading from draft, forward, reply
    AnchorElementsSource[AnchorElementsSource["ContentChangedFromSetContent"] = 1] = "ContentChangedFromSetContent";
})(AnchorElementsSource || (AnchorElementsSource = {}));
export default function processAnchorElements(allLinks, hiddenReferenceAttachments, source, attachmentPlugin, viewState, parentItemIdWrapper, infoBarAddHandler, infoBarRemoveHandler, processedLinkIds) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var sharePointLinks, start, i, link, url, i, sharePointLink, response, datapoint;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    sharePointLinks = [];
                    start = Date.now();
                    for (i = 0; i < allLinks.length; i++) {
                        link = allLinks[i];
                        if (shouldProcessLink(link, hiddenReferenceAttachments)) {
                            url = getUrl(link);
                            if (!isSharePointLink(url)) {
                                continue;
                            }
                            switch (source) {
                                case AnchorElementsSource.PasteHtml:
                                    logUsage(datapoints.AttachmentComposeSPLinksFromPaste.datapoint.name);
                                    break;
                                case AnchorElementsSource.ContentChangedFromSetContent:
                                    logUsage(datapoints.AttachmentComposeSPLinksFromSetContent.datapoint.name);
                                    break;
                                default:
                                    break;
                            }
                            trySetIdAndClassName(link);
                            if (processedLinkIds.indexOf(link.id) === -1) {
                                sharePointLinks.push({ id: link.id, url: url });
                                processedLinkIds.push(link.id);
                            }
                        }
                    }
                    if (sharePointLinks.length < 10) {
                        logUsage(datapoints.AttachmentComposeUnderTenSPLinksFromAnchorElements.datapoint.name);
                    }
                    else {
                        logUsage(datapoints.AttachmentComposeAtLeastTenSPLinksFromAnchorElements.datapoint.name);
                    }
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < sharePointLinks.length)) return [3 /*break*/, 4];
                    sharePointLink = sharePointLinks[i];
                    return [4 /*yield*/, getSharingInformation(sharePointLink.url)];
                case 2:
                    response = _a.sent();
                    if (!attachmentPlugin.editor) {
                        datapoint = new PerformanceDatapoint(datapoints.ComposeEditorIsNullDuringProcessSPLinks.datapoint.name);
                        datapoint.addCustomData(datapoints.ComposeEditorIsNullDuringProcessSPLinks.datapoint.customData(i, sharePointLinks.length, Math.round((Date.now() - start) / 1000)));
                        datapoint.end();
                        return [2 /*return*/];
                    }
                    handleGetSharingInfoResponse(sharePointLink.id, viewState, parentItemIdWrapper, response, infoBarAddHandler, infoBarRemoveHandler);
                    _a.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function getUrl(link) {
    var url = link.getAttribute(ORIGINALSRC_ATTRIBUTE_NAME);
    if (url && url.length > 0) {
        return url;
    }
    return link.href;
}
//# sourceMappingURL=processAnchorElements.js.map